import * as React from 'react';
import MerchantCategory from '../../../../domain/entities/MerchantCategory';
import css from './index.module.scss';
import ServiceFooter from './ServiceFooter';
import SiteFooter from './SiteFooter';

export interface Props {
  categories?: MerchantCategory[];
}

class GlobalFooter extends React.PureComponent<Props & React.HTMLProps<{}>> {
  public static defaultProps: Props = {
    categories: [],
  };

  public render() {
    const { categories } = this.props;

    return (
      <footer className={css.GlobalFooter}>
        {categories && categories.length > 0 && (
          <ServiceFooter categories={categories} />
        )}
        <SiteFooter />
      </footer>
    );
  }
}

export default GlobalFooter;
